<div class="violation-rules-table">
  @if (categoryDisplayName || categoryLink) {
    <div class="violation-rules-table-header">
      @if (categoryDisplayName) {
        <div class="violation-rules-table-header-title" (click)="$event.stopPropagation()">
          {{ categoryDisplayName | beautifyDisplayString }}
        </div>
      }

      @if (categoryLink) {
        <app-anchor-link [navigation]="categoryLink" class="violations-rules-table__link">
          <img class="violations-rules-table__link-icon" src="assets/images/common/link.svg" />
          {{ categoryCode | beautifyDisplayString }}
        </app-anchor-link>
      }
    </div>
  }

  <app-table
    (rowOnClick)="onRowClicked($event)"
    (rowActionOnClick)="actionOnClick($event)"
    [isLoading]="isLoading()"
    [isScrollable]="true"
    [sortedColumn]="sortedColumn()"
    [tableColumns]="tableColumns"
    [tableRows]="tableData()"
    [withActionsIcon]="true"
    [withActions]="true"
    [noData]="isEmptyTable()"
    (sortedColumnChange)="onSortedColumnChange($event)"
  >
  </app-table>
</div>
